import { render } from "./MyToolBox.vue?vue&type=template&id=4a4b0a85&scoped=true&lang=pug"
import script from "./MyToolBox.vue?vue&type=script&lang=js"
export * from "./MyToolBox.vue?vue&type=script&lang=js"

import "./MyToolBox.vue?vue&type=style&index=0&id=4a4b0a85&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4b0a85"]])

export default __exports__